module.exports = __webpack_public_path__ + "components/bookings-online-payment-method/static/belfius-9213b1a61555b5561e4ca8f755ec2ba6.svg";